import { render } from "./PluginPathLink.vue?vue&type=template&id=03f37e12&ts=true"
import script from "./PluginPathLink.vue?vue&type=script&lang=ts"
export * from "./PluginPathLink.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__